import React from 'react';
import classes from 'classnames';
import { useAdminTranslation } from '@/admin/hooks/useAdminTranslation';
import styles from './Statistics.module.scss';
import { StudentMetricsDashboardKpis } from '@/school-management/types/generate-report';
import StatsCard from '@/components/school-management/StatsCard/StatsCard';
import { formatMinutes } from '@/utils/formatters';

interface StatisticsProps {
  data?: StudentMetricsDashboardKpis;
  totalStudents: number;
  className?: string;
}

const calculatePercentage = (value: number, total: number): string => {
  if (total <= 0 || value <= 0) return '';
  return `${Math.floor((value / total) * 100)}%`;
};

const Statistics: React.FC<StatisticsProps> = ({ data, totalStudents, className }) => {
  const { t } = useAdminTranslation();

  return data ? (
    <div
      className={classes(styles.statistics, {
        [className || '']: !!className,
      })}
    >
      <StatsCard
        disableFallback={false}
        value={data.totalActivitiesPassed === 0 ? '0 ' : data.totalActivitiesPassed}
        percentage={`${data.passRate}%`}
        label={t('studentMetricsDashboard.charts.kpis.totalActivitiesPassed.label')}
        tooltip={t('studentMetricsDashboard.charts.kpis.totalActivitiesPassed.tooltip') || ''}
      />
      <StatsCard
        disableFallback={false}
        value={data.studentsThatPassedLevel === 0 ? '0 ' : data.studentsThatPassedLevel}
        percentage={calculatePercentage(data.studentsThatPassedLevel, totalStudents)}
        label={t('studentMetricsDashboard.charts.kpis.studentsThatPassedLevel.label')}
        tooltip={t('studentMetricsDashboard.charts.kpis.studentsThatPassedLevel.tooltip') || ''}
      />
      <StatsCard
        disableFallback={false}
        value={`${data.failureRate}%`}
        label={t('studentMetricsDashboard.charts.kpis.failureRate.label')}
        tooltip={t('studentMetricsDashboard.charts.kpis.failureRate.tooltip') || ''}
      />
      <StatsCard
        disableFallback={true}
        value={formatMinutes(data.totalTimeSpentSeconds)}
        label={t('studentMetricsDashboard.charts.kpis.totalTimeSpent.label')}
        tooltip={t('studentMetricsDashboard.charts.kpis.totalTimeSpent.tooltip') || ''}
      />
      <StatsCard
        disableFallback={true}
        value={formatMinutes(data.averageTimeSpentSeconds)}
        label={t('studentMetricsDashboard.charts.kpis.averageTimeSpent.label')}
        tooltip={t('studentMetricsDashboard.charts.kpis.averageTimeSpent.tooltip') || ''}
      />
      <StatsCard
        disableFallback={false}
        value={`${data.passRate}%`}
        label={t('studentMetricsDashboard.charts.kpis.passRate.label')}
        tooltip={t('studentMetricsDashboard.charts.kpis.passRate.tooltip') || ''}
      />
    </div>
  ) : (
    <></>
  );
};

export default Statistics;
